var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('v-col',[_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.items,"dense":"","fixed-header":"","search":_vm.selectedMonthsAsString,"custom-filter":_vm.filterByMonths}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }